import _ from 'lodash'

/**
 * @returns {Object<Number,Object>} the values for each of the fields, keyed
 * by field ID
 */
function getFieldValues(model, record) {
	let data = {}
	_.forEach(model.get('fields'), (field, index) => {
		var value = _.get(record, `record.${index}`)
		// displays ints as ints, e.g. as 25 instead of 25.0
		var possibleInt = parseInt(value)
		// use toString() and === because when a string value has leading zeroes, the ==
		// will evaluate to true. e.g. "0123" == 123 is true
		if (possibleInt.toString() === value) {
			value = possibleInt
		}
		data[field.id] = value
	})
	return data
}

export default getFieldValues

getFieldValues.__filename__ = 'datasets/records/get-field-values.js'
